import { PageProvider } from '../PageProvider';
import { Headers } from '../types';
import { ApiClientFactory, ApiClientFactoryInterface } from './clients';

export class PageProviderFactory {
  private readonly apiClientFactory: ApiClientFactoryInterface;

  constructor(baseUrl: string, headers: Headers) {
    this.apiClientFactory = new ApiClientFactory(`${baseUrl}/api/v1/page`, headers);
  }

  public createPageProvider(): PageProvider {
    return new PageProvider(this.apiClientFactory.createClient());
  }
}
